const usersData = [
    {
        id: 1,
        title: 'Users',
        number: '2.2k',
        percentage: '1.2%',
        img: 'AiOutlineUser',
        position: 'up',
        data: [
            ["Year", "Sales"],
            ["2017", 1000],
            ["2018", 770],
            ["2019", 660],
            ["2020", 1030],
        ]
    },
    {
        id: 2,
        title: 'Sessions',
        number: '3.85k',
        percentage: '1.2%',
        img: 'MdOutlineTimer',
        position: 'down',
        data: [
            ["Year", "Sales"],
            ["2017", 900],
            ["2005", 470],
            ["2019", 760],
            ["2020", 830],
        ]
    },
    {
        id: 3,
        title: 'Sessions Duration',
        number: '1 min',
        percentage: '1.1%',
        img: 'GiStopwatch',
        position: 'down',
        data: [
            ["Year", "Sales"],
            ["2017", 100],
            ["2005", 370],
            ["2019", 760],
            ["2020", 430],
        ]
    },
    {
        id: 4,
        title: 'Bounce Rate',
        number: '24.03%',
        percentage: '1.2%',
        img: 'BsGraphDown',
        position: 'up',
        data: [
            ["Year", "Sales"],
            ["2017", 950],
            ["2005", 1120],
            ["2019", 860],
            ["2020", 890],
        ]
    }
]

export default usersData